module.exports = __webpack_public_path__ + "user.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/user.png
// module id = 2186
// module chunks = 13